define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var historyUtil = {};
    var Backbone = require('../../node_modules/backbone/backbone');

    /**
     * IE10/IE11 sometimes throws error when accessing window.history.state
     * @returns object or null
     */
    function getWindowHistoryState() {
         try {
             return window.history.state;
         } catch (e) {
             return null;
         }
    }

    _.extend(historyUtil, {

        /**@deprecated 16.3.0
         * use `state` property*/
        getState: function() {
            return historyUtil.state;
        },

        /**@deprecated 16.3.0
         * use `isPushSupport` property*/
        hasPushSupport: historyUtil.isPushSupport,

        isPushSupport: (function() {
            historyUtil.isPushSupport = Boolean(window.history.pushState) && !_.isUndefined(getWindowHistoryState());
            return historyUtil.isPushSupport;
        })(),

        pushState: function(state, title, url) {
            if (location.href !== historyUtil.baseURI) {
                return;
            }

            url = url || window.location.href;
            title = title != null || document.title;

            window.history.pushState(state, title, url);

            historyUtil._updateBackboneFragment();
        },

        replaceState: function(state, title, url) {
            if (location.href !== historyUtil.baseURI) {
                return;
            }

            url = url || window.location.href;
            title = title != null ? title : document.title;

            // IE10/IE11 fix
            if (url === undefined) {
                url = null;
            }

            if (url && !/^\w+:\/\//.test(url)) {
                url = url.replace(/^\/?/, '/');
            }

            window.history.replaceState(state, title, url);

            historyUtil._updateBackboneFragment();
        },

        extendState: function(state, title, url) {
            historyUtil.replaceState(_.extend({}, this.state, state), title, url);
        },

        _updateBackboneFragment: function() {
            if (Backbone.History.started) {
                Backbone.history.fragment = Backbone.history.getFragment();
            }
        }

    });

    Object.defineProperty(historyUtil, 'state', {
        configurable: true,
        get: function() {
            return getWindowHistoryState() || {};
        },
        set: function() {
            throw new Error('`state` is read only property. Use `pushState` or `replaceState` to set history state');
        }
    });

    Object.defineProperty(historyUtil, 'baseURI', {
        configurable: true,
        get: function() {
            var baseURI = document.baseURI;

            // IE workaround for the lack of document.baseURI property
            if (!baseURI) {
                var baseTags = document.getElementsByTagName('base');

                baseURI = baseTags.length ? baseTags[0].href : document.URL;
            }

            return baseURI;
        }
    });

    module.exports = historyUtil;
});
